import template from './_message-panel.pug'

//const POSITION_ICON = require('assets/images/ico-group-user.png')

// @vue/component
export default {
  template: template(),

  props: {
    message: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      showMessage: true,
      url: this.$store.getters.urlBaseMap,
      attribution: this.$store.getters.attributionBaseMap,
      zoom: 13
    }
  },

  computed: {
    googleMapsApiKey() {
      return this.$store.getters.googleMapsApiKey
    },

    mapEngine() {
      return this.$store.getters.mapEngine
    },

    osmUrl() {
      return this.$store.getters.osmUrl
    },

    osmAttribution() {
      return this.$store.getters.osmAttribution
    },

    noBusStyle() {
      return [{featureType: 'transit.station.bus', stylers: [{visibility: 'off'}]}]
    },

    showCategory() {
      return this.message.category !== 'unassigned'
    },

    stateSolved() {
      return this.message.response
    },

    mapPosition() {
      if (this.message.lat && this.message.lng) {
        return {lat: this.message.lat, lng: this.message.lng}
      }
      return undefined
    },

    municipality() {
      return this.$store.state.municipality
    },

    timeZone() {
      return this.municipality.time_zone
    },

    momentDate() {
      if (this.timeZone) return moment(this.message.created_at).tz(this.timeZone)
      return moment(this.message.created_at)
    },

    momentResponseDate() {
      if (this.timeZone) return moment(this.message.response_date).tz(this.timeZone)
      return moment(this.message.response_date)
    },

    messageInformationArrowOpenerClass() {
      return {
        'ns-icon-angle-up': this.showMessage,
        'ns-icon-angle-down': !this.showMessage,
        'text-gray1': this.showMessage
      }
    }
  },

  created() {
    if (this.stateSolved) this.showMessage = false
  },

  methods: {
    userIcon() {
      const PointIcon = L.Icon.extend({
        options: {data: null, iconUrl: POSITION_ICON, iconAnchor: [30, 30]}
      })

      return new PointIcon({})
    }
  }
}
